import type { FC } from 'react';

import type { FormattedTextProps } from '../types';

export const HelpText: FC<FormattedTextProps> = ({ children, dynamicValues }) => {
  const content = typeof children === 'string' ? children : '';
  const formattedContent = parseMarkdown(content, dynamicValues);

  return <span dangerouslySetInnerHTML={{ __html: formattedContent }} />;
};

// Utils
const markdownBoldRegex = /\*\*(.*?)\*\*/g;
const markdownUnderlinedReg = /__(.*?)__/g;
const parseMarkdown = (text: string, dynamicValues?: Record<string, string | number>): string => {
  let formattedText = text
    .replace(markdownBoldRegex, '<b>$1</b>') // Replace ** with <b></b> for bold text
    .replace(markdownUnderlinedReg, '<u>$1</u>'); // Replace __ with <u></u> for underlined text

  // Substitute dynamic values
  if (dynamicValues) {
    Object.keys(dynamicValues).forEach((key) => {
      const value = dynamicValues[key];
      const regex = new RegExp(`@@${key}@@`, 'g');
      formattedText = formattedText.replace(regex, value.toString());
    });
  }

  return formattedText;
};
